import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import WhyChooseUs from './components/WhyChooseUs';
import ProgramsPreview from './components/ProgramsPreview';
import GallerySection from './components/GallerySection';
import CTASection from './components/CTASection';
import TestimonialsSection from './components/TestimonialsSection';
import SEO, { siteUrl } from '@/components/feature/SEO';

export default function Home() {
  return (
    <main>
      <SEO
        title="Moin Khan Boxing Academy — Elite Boxing Training in Islamabad, Pakistan"
        description="Moin Khan Boxing Academy offers professional boxing training in Islamabad with private coaching, group classes, youth programs, and home training. Train under an international boxing champion. Build strength, discipline, and confidence."
        keywords="boxing academy, boxing training Islamabad, private boxing coach, group boxing classes, youth boxing program, home boxing training, Moin Khan, combat sports training"
        canonicalUrl={siteUrl ? `${siteUrl}/` : undefined}
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'SportsActivityLocation',
            '@id': `${siteUrl}/#organization`,
            name: 'Moin Khan Boxing Academy',
            url: siteUrl,
            description: 'Elite boxing training academy in Islamabad offering private coaching, group classes, youth programs, and home training led by international boxing champion Moin Khan.',
            image: 'https://static.readdy.ai/image/a84fce21c15147349888dd3eeb9b8000/e45f316ea85d5f4030e426237dbf23c5.png',
            address: {
              '@type': 'PostalAddress',
              addressLocality: 'Islamabad',
              addressRegion: 'Islamabad Capital Territory',
              addressCountry: 'PK',
            },
            telephone: '+923179699957',
            sameAs: ['https://wa.me/923179699957'],
            openingHoursSpecification: [
              {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                opens: '06:00',
                closes: '21:00',
              },
            ],
          },
          {
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            '@id': `${siteUrl}/#website`,
            url: siteUrl,
            name: 'Moin Khan Boxing Academy',
            description: 'Elite boxing training in Islamabad — private coaching, group classes, youth programs, and home training.',
            potentialAction: {
              '@type': 'SearchAction',
              target: {
                '@type': 'EntryPoint',
                urlTemplate: `${siteUrl}/?q={search_term_string}`,
              },
              'query-input': 'required name=search_term_string',
            },
          },
        ]}
      />
      <HeroSection />
      <StatsSection />
      <WhyChooseUs />
      <ProgramsPreview />
      <GallerySection />
      <CTASection />
      <TestimonialsSection />
    </main>
  );
}